import { useChatboxStore } from "../../store";
import { Email } from "./Email";
import { File } from "./File";
import { Image } from "./Image";
import { SuggestionMessage } from "./SuggestionMessage";
import { Text } from "./Text";
import { ToolCallMessage } from "./ToolCall";
import { MessageForm } from "./form";
import {
  MessagingChannelType,
  MessagingEventType,
  MessagingMessageType,
  type MessagingMessage,
} from "@/model/messaging";
import { IoImageOutline } from "react-icons/io5";

interface MessageContentProps {
  message: MessagingMessage;
}

export const MessageContent = ({ message }: MessageContentProps) => {
  const {
    use: { options },
  } = useChatboxStore();
  const { customizedContent } = options?.bubble ?? {};

  if (
    customizedContent &&
    Object.hasOwn(customizedContent, message.payload.messageType)
  ) {
    const fn = customizedContent[message.payload.messageType];
    return fn(message);
  }

  if (message.payload.messageType === MessagingMessageType.File) {
    return <File message={message} />;
  }

  if (message.payload.messageType === MessagingMessageType.Image) {
    if (!message.payload.media?.mediaUrl) {
      return <IoImageOutline className="h-10 w-10 animate-pulse" />;
    }
    // eslint-disable-next-line jsx-a11y/alt-text
    return <Image message={message} />;
  }

  if (message.payload.messageType === MessagingMessageType.Form) {
    return <MessageForm message={message} />;
  }

  if (message.payload.channel === MessagingChannelType.Email) {
    return <Email message={message} />;
  }

  if (message.eventType === MessagingEventType.AIToolCall) {
    return <ToolCallMessage message={message} />;
  }

  if (message.eventType === MessagingEventType.SuggestionV2) {
    return <SuggestionMessage message={message} />;
  }

  return <Text message={message} />;
};
